const STREAM_TITLE_PREFIX = "Stream for ";

/**
 * Builds the slug segment used in `/memorial-page/{id}/{slug}` URLs from a
 * stream/deceased title, matching the pattern used elsewhere (e.g.
 * BookingDetails.tsx's buildMemorialUrl).
 */
export function slugFromStreamTitle(streamTitle?: string): string {
  const title = streamTitle || "";
  const nameForSlug = title.startsWith(STREAM_TITLE_PREFIX)
    ? title.slice(STREAM_TITLE_PREFIX.length)
    : title;
  const trimmed = nameForSlug.trim();
  return trimmed ? encodeURIComponent(trimmed.replace(/\s+/g, "-")) : "memorial";
}
